import styled from "styled-components";

export const TableContainer = styled.div`
  overflow-y: auto;
  /* max-height: 300px; */
  table {
    thead {
      border-bottom: 1px solid #ececee;
      tr {
        background: #fff;
        border-style: none;
        th {
          color: #000000;
          font-size: clamp(12px, 0.833vw, 16px);
          font-family: "latosemibold";
          padding: clamp(15px, 1.042vw, 20px);
          background: #dcedf7;
          white-space: nowrap;
          border: none;
        }
      }
    }
    tbody {
      tr {
        background: #f7f9fa;
        border: 1px solid #ececee;
        border-top: 0;
        td {
          padding: clamp(15px, 1.042vw, 20px);
          color: #000000;
          font-size: clamp(10px, 0.729vw, 14px);
          font-family: "latoregular";

          :first-child {
            font-family: "latosemibold";
          }
        }
        :nth-child(even) {
          background: #fff;
        }
      }
    }
  }
`;
